import { useState } from "react";

import { ISharedItemNote } from "@/Common/Api/PortalCommunication/ISharedItemNote";
import { SharedItemClient } from "@/Common/Api/SharedItem/SharedItemClient";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { SharedItem } from "@/Common/Models/Portal/SharedItem/SharedItem";
import { SharedItemNote } from "@/Common/Models/Portal/SharedItem/SharedItemNote";
import { LinkButton } from "@/DesignSystem";
import { PortalCommunicationNotesList } from "./PortalCommunicationNotesList";

import styles from "./PortalCommunicationsMessagesNote.module.scss";

interface IPortalCommunicationsMessagesNoteProps {
    sharedItem: SharedItem;
    onSharedItemUpdate: (sharedItemNote: ISharedItemNote) => void;
}

export function PortalCommunicationsMessagesNote(props: Readonly<IPortalCommunicationsMessagesNoteProps>): JSX.Element {
    const { getText } = useTranslation();
    const [note, setNote] = useState<string>("");
    const [openNoteSection, setOpenNoteSection] = useState<boolean>(false);
    const savePortalCommunicationNote = async (): Promise<void> => {
        const insertedSharedItemNote = await SharedItemClient.saveSharedItemNote(props.sharedItem.SharedItemId, note);

        if (insertedSharedItemNote) {
            const sharedItemNote = insertedSharedItemNote.SharedItemNote;

            setNote("");
            setOpenNoteSection(false);
            props.onSharedItemUpdate(sharedItemNote);
        }
    };

    if (!props.sharedItem)
        return <></>;

    return (
        <div className={styles.notesContainer}>
            <div className={styles.notesLabel}>{getText("NotesLabel")}</div>
            <div className={styles.addNoteSection}>
                {openNoteSection && (
                    <>
                        <textarea
                            className={`${styles.textBoxContainer} form-control`}
                            value={note}
                            id="note-textbox-portal-communication-details"
                            onChange={e => setNote(e.target.value)}
                            maxLength={255}
                            rows={2}
                            autoFocus
                        />
                        <div className={styles.actionButtonContainer}>
                            <ButtonControl
                                className="btn btn-default btn-sm push-right-5"
                                onClick={() => { setOpenNoteSection(false); setNote(""); }}
                                label={getText("CancelLabel")}
                            />
                            <ButtonControl
                                className="btn btn-primary btn-sm"
                                onClick={() => savePortalCommunicationNote()}
                                label={getText("SaveLabel")}
                                disabled={!note}
                                dataCy="portal-communication-notes-popup-save-button"
                            />
                        </div>
                    </>
                )}
                {!openNoteSection && <div><LinkButton label={getText("AddNoteLabel")} underline={false} onClick={() => setOpenNoteSection(true)} /></div>}
                <div className={styles.noteListContainer}>
                    {!!props.sharedItem.Notes.length && (
                        <PortalCommunicationNotesList
                            notes={props.sharedItem.Notes.map(p => SharedItemNote.fromResponseModel(p))}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
